import m from 'mithril'

class ErrorPage {
    constructor(vnode) {

    }
    view(vnode) {
        return [
        m(".h-100.w-100.d-flex.justify-content-center.align-items-center.position-fixed.bg-info",
           m("",
                m(".row",
                    m(".d-flex.align-items-center.text-center.error-page",
                        m(".col-12.mx-auto.text-white",
                            [
                                m(".row.align-items-center.d-flex.flex-row",
                                    [
                                        m(".col-lg-6.text-lg-right.pr-lg-4",
                                            m("h1.display-1.mb-0","404")
                                        ),
                                        m(".col-lg-6.error-page-ider.text-lg-left.pl-lg-4",
                                            [
                                                m("h2","SORRY!"),
                                                m("h5.mt-2","找不到此頁面")
                                            ]
                                        )
                                    ]
                                ),
                                m(".row.mt-5",
                                    m(".col-12.text-center.mt-xl-2",
                                        m("a.btn.btn-outline-light.font-weight-medium[href='#!/']","回首頁")
                                    )
                                ),
                                m(".row.mt-5",
                                    m(".col-12.mt-xl-2",
                                        m("p.text-white.font-weight-medium.text-center",
                                            [
                                                "都市發展局 ",
                                                m.trust("&copy;"),
                                                " 2019  版權所有"
                                            ]
                                        )
                                    )
                                )
                            ]
                        )
                    )
                )
            )
        )
        ]
    }
}

export default ErrorPage